import { render, staticRenderFns } from "./JgBespokeDouble.vue?vue&type=template&id=47e4c65e&scoped=true&"
import script from "./JgBespokeDouble.vue?vue&type=script&lang=ts&"
export * from "./JgBespokeDouble.vue?vue&type=script&lang=ts&"
import style0 from "./JgBespokeDouble.vue?vue&type=style&index=0&id=47e4c65e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e4c65e",
  null
  
)

export default component.exports